import './SeasonDisplay.css';
import React from 'react';

const seasonConfig = {
    summer:{
        text:'Lets hit the beach BABBYYYYY!!!',
        
        iconName:'sun'
    },
    winter:{
        text:'Bro! It\'s fucking Chillyyyyy!!!',
        iconName:'snowflake'
    }
};

const getSeason =(lat, month)=>{
    if(month>2 && month<9){
        return lat>0 ? 'summer':'winter';
    }else{
        return lat>0 ? 'winter':'summer';
    }

}

const SeasonDisplay = (props) =>{
    const season = getSeason(props.lat, new Date().getMonth());
    const { text, iconName } = seasonConfig[season];
    // console.log(season);
    // const text = season === 'winter' ? 'Bro! It\'s fucking Chillyyyyy!!!' : 'Lets hit the beach BABBYYYYY!!!';
    // const icon = season === 'winter' ? 'snowflake' :'sun';
    return(
        <div className={`season-display ${season}`}>
            <i className={`icon-left massive ${iconName} icon`} />
           <h1>{text}</h1>  
           <i className={`icon-right massive ${iconName} icon`} />
        </div>
    );
};

export default SeasonDisplay;